import tmpl from './view.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	render: function()
	{
		this.doRender({
			page: this.model
		});
	}
});

